import type DxfArrayScanner from 'dxf-parser/dist/DxfArrayScanner.js'
import type { IGroup } from 'dxf-parser/dist/DxfArrayScanner.js'
import type { IEntity, IPoint } from 'dxf-parser/dist/entities/geomtry.js'
import * as helpers from '@/plugins/cad/module/parser/parseHelpers'

/** DXF SPLINE 实体解析结果，覆盖 B 样条曲线全部几何与拓扑字段 */
export interface IDxfSplineEntity extends IEntity {
  /** 控制点列表，按参数 u 递增顺序排列 */
  controlPoints?: IPoint[]
  /** 拟合点列表，曲线应通过这些点 */
  fitPoints?: IPoint[]
  /** 起点切向量 */
  startTangent?: IPoint
  /** 终点切向量 */
  endTangent?: IPoint
  /** 节点向量值列表 */
  knotValues?: number[]
  /** 每个控制点对应的权重，有理样条时使用 */
  weights?: number[]
  /** 是否闭合 */
  closed?: boolean
  /** 是否周期 */
  periodic?: boolean
  /** 是否为有理样条 */
  rational?: boolean
  /** 是否平面样条 */
  planar?: boolean
  /** 是否为退化为直线 */
  linear?: boolean
  /** 样条曲线阶数 */
  degreeOfSplineCurve?: number
  /** 节点数量 */
  numberOfKnots?: number
  /** 控制点数量 */
  numberOfControlPoints?: number
  /** 拟合点数量 */
  numberOfFitPoints?: number
  /** 所在平面的法向量 */
  normalVector?: IPoint
}

/** DXF SPLINE 实体解析器，注册到 dxf-parser 后用于样条曲线解析 */
export default class SplineEntityParser {
  /** dxf-parser 约定的实体名称键 */
  public ForEntityName = 'SPLINE' as const

  /**
   * 解析单个 SPLINE 实体。
   *
   * @param scanner - DXF 组码扫描器
   * @param curr - 当前已读取的组码项
   * @returns 解析后的 SPLINE 实体对象
   */
  public parseEntity(scanner: DxfArrayScanner, curr: IGroup) {
    const entity = { type: curr.value } as IDxfSplineEntity
    curr = scanner.next()

    while (!scanner.isEOF()) {
      if (curr.code === 0) {
        break
      }

      switch (curr.code) {
        case 10:
          entity.controlPoints ||= []
          entity.controlPoints.push(helpers.parsePoint(scanner))
          break
        case 11:
          entity.fitPoints ||= []
          entity.fitPoints.push(helpers.parsePoint(scanner))
          break
        case 12:
          entity.startTangent = helpers.parsePoint(scanner)
          break
        case 13:
          entity.endTangent = helpers.parsePoint(scanner)
          break
        case 40:
          entity.knotValues ||= []
          entity.knotValues.push(curr.value as number)
          break
        case 41:
          entity.weights ||= []
          entity.weights.push(curr.value as number)
          break
        case 70:
          if (((curr.value as number) & 1) !== 0) {
            entity.closed = true
          }
          if (((curr.value as number) & 2) !== 0) {
            entity.periodic = true
          }
          if (((curr.value as number) & 4) !== 0) {
            entity.rational = true
          }
          if (((curr.value as number) & 8) !== 0) {
            entity.planar = true
          }
          if (((curr.value as number) & 16) !== 0) {
            entity.planar = true
            entity.linear = true
          }
          break
        case 71:
          entity.degreeOfSplineCurve = curr.value as number
          break
        case 72:
          entity.numberOfKnots = curr.value as number
          break
        case 73:
          entity.numberOfControlPoints = curr.value as number
          break
        case 74:
          entity.numberOfFitPoints = curr.value as number
          break
        case 210:
          entity.normalVector = helpers.parsePoint(scanner)
          break
        default:
          helpers.checkCommonEntityProperties(entity, curr, scanner)
          break
      }

      curr = scanner.next()
    }

    return entity
  }
}
